document.addEventListener("DOMContentLoaded", function () {
  const expandButton = document.getElementById("expand-button");
  const blockList = document.getElementById("block-list");
  const buttonWrapper = document.querySelector(".button-wrapper");

  expandButton.addEventListener("click", function () {
    const lang = document.documentElement.lang;

    const texts = {
        "pl": {
            expand: "Rozwiń przypisy",
            collapse: "Zwiń przypisy"
        },
        "en": {
            expand: "Expand notes",
            collapse: "Collapse notes"
        },
    };

    const {expand, collapse} = texts[lang] || texts["en"];

    if (blockList.classList.contains("collapsed")) {
        blockList.classList.remove("collapsed");
        buttonWrapper.classList.add("flip");
        expandButton.innerText = collapse;
    } else {
        blockList.classList.add("collapsed");
        expandButton.innerText = expand;
        buttonWrapper.classList.remove("flip");
    }
  });
});